import { defineAction } from '~/prix'
import { z } from 'zod'
import bullUpdateAction from './bullUpdate.action.json' with { type: 'json' }
import { bullObject } from '../bullObject'

const bullUpdateDefinition = defineAction({
  ...bullUpdateAction,

  input: bullObject.pick({ id: true, name: true, breed: true }).partial().required({ id: true }),
  output: z.object({}),
})

export default bullUpdateDefinition
